import { render, staticRenderFns } from "./WelcomePhisicalTco.vue?vue&type=template&id=1fed25f9"
import script from "./WelcomePhisicalTco.vue?vue&type=script&lang=js"
export * from "./WelcomePhisicalTco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports